module.exports = __webpack_public_path__ + "img/small-11.c79e4171.webp";